<template>
  <div
    class="flex-col flex-1"
    :class="{
      'middle-presentation': true,
      'presenting-mode': isPresenting,
      'capture-mode': $store.state.isScreenCapture,
      'transparent-bg': slideActive.type == 'image' &&
        slideActive.imageType == 'background',
      'presenting-mode-share': isPresenting,
    }"
    :style="{'width': 'unset' }"
  >
    <div
      id="middle-slide-intro"
      class="slide-intro"
      :class="{
        [$store.state.currentSlideCanvas]: true,
        'flex flex-col': !isPresenting,
      }"
    >
      <div
        id="middle-canvas"
        class="ahaslide-legacy-css wrap-slide-intro vertical layout center center-justified"
        :class="{'fit': isPresenting}"
      >
        <SlideWrapperForSharingView
          @selectPrevSlide="selectPrevSlide"
          @selectNextSlide="selectNextSlide"
          @handleNextSlideWhenPlayingQuiz="handleNextSlideWhenPlayingQuiz"
        />
        <SharePresentationBar />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import config from '@/config'
import EventBus from '@/eventBus'
import constants from '@/constant'
import QuizStatuses from '@/constant/QuizStatuses'

import util from '@/util'
import Socket from '@/socket'

// components
import SharePresentationBar from '@/components-v2/presentation-editor/SharePresentationBar.vue'

// services
import cookie from '@/services/cookie'

import {
  SET_CURRENT_SLIDE_MODE,
} from '@/vuex/types'

export default {
  components: {
    SharePresentationBar,
    SlideWrapperForSharingView: () => import('@/components-v2/presentation-editor/middle/SlideWrapperForSharingView.vue'),
  },
  data() {
    return {
      debouceTimeNextSlide: null,
      presentationCopyId: null,
      timer: null,
      isGuestUser: !!cookie.getValue('aha-guest-user'),
      QuizStatuses,
      allowShowSlideType: [
        'wordCloud',
        'imageChoice',
        'multipleChoice',
        'question',
        'leaderboard',
        'spinnerWheel',
      ],
    }
  },
  computed: {
    ...mapState({
      isScreenCapture: (state) => state.isScreenCapture,
      activeSlideId: (state) => state.activeSlideId,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,

    }),
    ...mapGetters(['isPresenting']),

    hasPrevSlide() {
      return this.$store.getters.currentSlideIndex > 0
    },
    hasNextSlide() {
      return (
        this.$store.getters.currentSlideIndex <
        this.$store.state.presentation.slides.length - 1
      )
    },

  },
  watch: {
    '$store.getters.isPresenting': function watchIsPresenting(isPresenting) {
      if (isPresenting) {
        document.body.classList.add('no-scroll')
        document.body.classList.add('body-presenting')
      } else {
        const { presentation } = this.$store.state
        if (presentation.showBranding || presentation.showExport ||
        presentation.showSetting || presentation.showShare) {
          document.body.classList.remove('body-presenting')
        } else {
          document.body.classList.remove('no-scroll')
          document.body.classList.remove('body-presenting')
        }

        // when exit presenting mode
        if (this.$store.state.slideActive.type === 'pickAnswer') {
          this.updateSlideActiveAction({
            quizStatus: constants.QuizStatuses.LOBBY_SCREEN,
            hideResult: false,
            showCorrectOption: true,
          })
        }
      }

      if (this.$store.state.continueQuiz) {
        this.$store.state.continueQuiz = false
      }
      this.$store.state.presentation.presenting = isPresenting
    },
  },
  destroyed() {
    EventBus.$off('template-preview:go-to-slide', this.goToSlide)

    this.$store.dispatch(SET_CURRENT_SLIDE_MODE, '')
    document.body.classList.remove('no-scroll')
    document.body.classList.remove('body-presenting')
  },

  mounted() {
    EventBus.$on('template-preview:go-to-slide', this.goToSlide)
    this.handleShowControlsOnHoverDevices()
    this.handleShowControlsOnTouchDevices()
  },
  methods: {
    ...mapActions([
      'updateSlideActiveAction',
      'setCurrentUserAction',
    ]),

    handleNextSlideWhenPlayingQuiz(type) {
      if (type === 'next') {
        this._autoNextSlide('keyboard')
      }

      if (type === 'prev') {
        this._autoPrevSlide('keyboard')
      }
    },
    handleShowControlsOnHoverDevices() {
      if (util.supportsTouch()) return
      this.$el.addEventListener('mousemove', () => {
        this.handleShowSlideControls()
      })
    },

    handleShowControlsOnTouchDevices() {
      if (!util.supportsTouch()) return
      this.$el.addEventListener('touchstart', () => {
        this.handleShowSlideControls()
      })
    },

    handleShowSlideControls() {
      if (this.isPresenting) {
        EventBus.$emit('next-back-slide-arrows: update isShowingControls', true)
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            EventBus.$emit('next-back-slide-arrows: update isShowingControls', false)
          }, config.SLIDE_CONTROLS_TIMEOUT)
        } else {
          this.timer = setTimeout(() => {
            EventBus.$emit('next-back-slide-arrows: update isShowingControls', false)
          }, config.SLIDE_CONTROLS_TIMEOUT)
        }
      }
    },

    _getCurrentIndexSlide(currentSlideId) {
      return this.$store.state.presentation.slides.findIndex((item) => {
        return item.id == currentSlideId
      })
    },
    selectPrevSlide(mode) {
      if (
        mode != 'icon-arrow-right' &&
        mode != 'icon-arrow-left' &&
        mode != 'swipe'
      ) {
        if (!this.checkShowAllBulletPoints('prev')) {
          EventBus.$emit('next-back-slide: update-bulletPointsIndex', this.checkShowAllBulletPoints('prev'), 'prev')

          return
        }
      }

      if (!this.hasPrevSlide) return
      this._autoPrevSlide(mode)
    },

    _autoPrevSlide(mode) {
      this.$store.state.controllerSocketId = Socket.getSocketId()

      const oldSlide = JSON.parse(JSON.stringify(this.$store.state.slideActive))
      const currentSlideId = oldSlide.id
      this.$store.dispatch('updateSlideActive', {
        activeTab: null,
        id: null,
      })
      if (this.$store.state.continueQuiz) {
        this.$store.state.continueQuiz = false
      }
      this.$store.state.transitionContent = ''
      setTimeout(() => {
        const item = this.$store.state.presentation.slides[
          this._getCurrentIndexSlide(currentSlideId) - 1
        ]
        this.$store.dispatch('setSlideActive', item)
        EventBus.$emit('updateNextSlide', item.id)

        this.$store.state.transitionContent = 'left'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')
      }, 0)
      util.mixpanelTracking(
        constants.eventCategories.PRESENTING_MODE,
        `Presentation > Presenting > Previous slide using ${mode}`,
        null,
        null,
        {
          qrCodeOpening: this.$store.state.isQRCodeVisible,
        },
      )
    },
    checkShowAllBulletPoints(mode) {
      const {
        type, showAllBulletPoints, SlideOptions, bulletPointsIndex,
      } = this.slideActive
      if (type !== 'bulletPoints' || showAllBulletPoints) return true
      if (mode == 'next') {
        if (SlideOptions && SlideOptions.length > bulletPointsIndex) return false

        return true
      }
      if (mode == 'prev') {
        if (!bulletPointsIndex) return true

        return false
      }

      return true
    },

    selectNextSlide(mode) {
      if (mode != 'keyboard') {
        this.$store.state.historyKeyboard = null
      }

      if (
        mode != 'icon-arrow-right' &&
        mode != 'icon-arrow-left' &&
        mode != 'swipe'
      ) {
        if (!this.checkShowAllBulletPoints('next')) {
          EventBus.$emit('next-back-slide: update-bulletPointsIndex', this.checkShowAllBulletPoints('next'), 'next')

          return
        }
      }
      if (!this.hasNextSlide) return
      this._autoNextSlide(mode)
    },

    _autoNextSlide(mode) {
      this.$store.state.controllerSocketId = Socket.getSocketId()

      const oldSlide = JSON.parse(JSON.stringify(this.$store.state.slideActive))
      const currentSlideId = oldSlide.id

      this.$store.dispatch('updateSlideActive', {
        activeTab: null,
        id: null,
      })
      this.$store.state.transitionContent = ''
      setTimeout(() => {
        if (!currentSlideId) return
        const nextIndex = this._getCurrentIndexSlide(currentSlideId) + 1
        const item = this.$store.state.presentation.slides[nextIndex]

        this.$store.dispatch('setSlideActive', item)
        this.$store.state.transitionContent = 'right'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')

        // Handle preload images, etc
        this.$emit('nextSlideHandler', nextIndex)
        EventBus.$emit('updateNextSlide', item.id)
      }, 0)
      util.mixpanelTracking(
        constants.eventCategories.PRESENTING_MODE,
        `Presentation > Presenting > Next slide using ${mode}`,
        null,
        null,
        {
          qrCodeOpening: this.$store.state.isQRCodeVisible,
        },
      )
    },

    goToSlide(currentSlideId) {
      this.$store.state.transitionContent = ''
      this.$store.dispatch('updateSlideActive', {
        activeTab: null,
        id: null,
      })
      setTimeout(() => {
        if (!currentSlideId) return
        const index = this.$store.state.presentation.slides.findIndex((slide) => {
          return slide.id == currentSlideId
        })
        const item = this.$store.state.presentation.slides[index]
        if (!item) return
        this.$store.dispatch('setSlideActive', item)
        this.$store.state.transitionContent = 'right'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')

        // Handle preload images, etc
        this.$emit('nextSlideHandler', index)
        EventBus.$emit('updateNextSlide', item.id)
      }, 0)
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.presenting-mode {
  &::v-deep {
    .transition-image-slide-bg {
      transition: background-image cubic-bezier(0.25, 1, 0.5, 1) 0.5s;
    }
    .slide-base-colour {
      transition: background-color cubic-bezier(0.25, 1, 0.5, 1) 0.5s;
    }
  }
}

.middle-presentation {
  position: relative;
  overflow-y: hidden;
  transition: all 0.3s ease;
}

.slide-intro {
  width: 100%;
  height: 100%;
  padding-top: 12px;

  &::v-deep .main-slide {
    position: relative;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: hidden;
  }
}
.middle-presentation.presenting-mode {
  background-color: #000;
}

.middle-presentation {
  & ::v-deep .slide-intro {
    .slide-content {
      padding: 8px;
      &.ideas-slide-content {
        padding: 8px 19px;
      }
    }
    .title-slide {
      line-height: 1.2;
      word-break: break-word;
    }
  }
}

.wrap-slide-intro {
  margin-bottom: 12px;
}

.middle-presentation.presenting-mode {
  overflow: hidden;
  background-color: #000;

  .wrap-slide-intro {
    background-color: #000;
    box-shadow: none;
    border-radius: 0;
    padding-top: initial;
    border: 0;
    height: 100%;
  }

  & ::v-deep .slide-intro {
    padding: 0;
    padding-bottom: 0;
    .main-slide {
      box-shadow: none;
      border-radius: 0;
      padding-top: initial;
      border: 0;
    }

    .top-header {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}

.middle-presentation.capture-mode {
  overflow-y: auto;
  overflow-x: hidden;
}

//Set font size for shared presentation Iphone5/se
@media (max-width: 568px) and (orientation: landscape) {
  .shared__presentation-title {
    font-size: 13px;
  }
  .shared__copy-presentation .btn {
    font-size: 12px;
  }
}

.middle-presentation {
  background: #f0f2f5;
  .slide-intro {
    &.screen-hd {
      font-size: 18px;
    }
  }
}
</style>
